import Stack from '@mui/material/Stack';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useAtom } from 'jotai';
import { useEffect } from 'react';
import { Outlet } from 'react-router';

import { LAYOUT_BREAKPOINT } from '@/constants/common';
import EnvironmentAlert from '@/layout/EnvironmentAlert';
import { isLayoutMobileAtom } from '@/store/layout';
import { isSidebarExpandedAtom, isSidebarOpenAtom } from '@/store/sidebar';

import { Topbar } from '../Topbar';
import useStyles from './Content.styles';

function Content() {
  const [isLayoutMobile, setIsLayoutMobile] = useAtom(isLayoutMobileAtom);
  const [isSidebarExpanded] = useAtom(isSidebarExpandedAtom);
  const [, setIsSidebarOpen] = useAtom(isSidebarOpenAtom);
  const { classes } = useStyles({ isLayoutMobile, isSidebarExpanded });
  const theme = useTheme();
  const matchMediaQuery = useMediaQuery(
    theme.breakpoints.up(LAYOUT_BREAKPOINT)
  );

  // changes layout behavior (mobile or desktop)
  useEffect(() => {
    setIsSidebarOpen(false);
    if (matchMediaQuery) {
      // desktop
      setIsLayoutMobile(false);
      return;
    }
    // mobile
    setIsLayoutMobile(true);
  }, [matchMediaQuery]);

  return (
    <div className={classes.content}>
      <div className={classes.contentSpacer} />
      <Stack direction="column" className={classes.contentOuter}>
        <EnvironmentAlert />
        <Topbar />
        <Stack direction="column" className={classes.contentInner}>
          <Outlet />
        </Stack>
      </Stack>
    </div>
  );
}

export default Content;
